import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_PERMISSIONS = "getPaginatedPermissions";
export const ALL_PERMISSIONS = "getAllPermissions";
export const FIND_BY_PERMISSION_NAME = "findByPermissionName";
export const CREATE_PERMISSION_FORM = "createPermissionForm";
export const DELETE_PERMISSION = "deletePermission";
export const GET_PERMISSION_DATA = "getPermissionData";
export const CREATE_PERMISSION = "createPermission";
export const UPDATE_PERMISSION = "updatePermission";
export const ADD_USER_TO_PERMISSION = "addUserToPermission";
export const DELETE_USER_FROM_PERMISSION = "deleteUserFromPermission";
export const ADD_ROLE_TO_PERMISSION = "addRoleToPermission";
export const DELETE_ROLE_FROM_PERMISSION = "deleteRoleFromPermission";


// mutation types

export const SET_PAGINATED_PERMISSIONS = "setPaginatedPermissions";
export const SET_ALL_PERMISSIONS = "setAllPermissions";
export const SET_PERMISSION_DATA = "setPermissionData";
export const SET_PERMISSION_META = "setPermissionMeta";
export const SET_PERMISSION_ERROR = "setPermissionError";
export const SET_PERMISSION_LOADING = "setPermissionLoading";
export const CLEAR_PERMISSION_ERROR = "clearPermissionError";
export const SET_IS_DISABLED_PERMISSION = "setIsDisabledPermission";


const state = {
    permissions: [],
    paginatedPermissions: [],
    permission_data: {},
    meta_permission : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPermissions(state) {
        return state.paginatedPermissions;
    },

    allPermissions(state) {
        return state.permissions;
    },

    getPermissionData(state) {
        return state.permission_data;
    },

    meta_permission(state) {
        return state.meta_permission;
    },

    
};

const actions = {
 
    [PAGINATE_ALL_PERMISSIONS](context, payload) {
        context.commit(SET_IS_DISABLED_PERMISSION, false);
        context.commit(SET_PERMISSION_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/permissions?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PERMISSION_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_PERMISSIONS, data);
                context.commit(SET_PERMISSION_META, data);
                context.commit(SET_PERMISSION_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_PERMISSION_LOADING, false);
            context.commit(SET_PERMISSION_ERROR, response.errors);
        });
        ;
        
    },

    [FIND_BY_PERMISSION_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_PERMISSION, false);
        context.commit(SET_PERMISSION_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByPermissionName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_PERMISSIONS]() {
        return new Promise(resolve => {
            ApiService.get('/permissionsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_PERMISSION_FORM](context) {
        context.commit(SET_PERMISSION_LOADING, false);
        context.commit(SET_PERMISSION_ERROR, false);
        context.commit(SET_IS_DISABLED_PERMISSION, false);
    },

    [GET_PERMISSION_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_PERMISSION, true);
        context.commit(SET_PERMISSION_LOADING, true);
        context.commit(CLEAR_PERMISSION_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/permission/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PERMISSION_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PERMISSION_DATA, response.data);
                    context.commit(SET_PERMISSION_LOADING, false);
                    context.commit(SET_IS_DISABLED_PERMISSION, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PERMISSION_LOADING, false);
                context.commit(SET_PERMISSION_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PERMISSION, true);
            });
        });
    },

    [CREATE_PERMISSION](context, payload) {
        context.commit(SET_PERMISSION_LOADING, false);
        context.commit(SET_IS_DISABLED_PERMISSION, true);
        context.commit(CLEAR_PERMISSION_ERROR);
        return ApiService.post("/permission/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PERMISSION_ERROR);
            }
            else{
                context.commit(SET_PERMISSION_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "İzin başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_PERMISSION_ERROR);
                context.commit(SET_IS_DISABLED_PERMISSION, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PERMISSION_LOADING, false);
            context.commit(SET_PERMISSION_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PERMISSION, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_PERMISSION](context, payload) {
        context.commit(SET_PERMISSION_LOADING, true);
        context.commit(SET_IS_DISABLED_PERMISSION, true);
        context.commit(CLEAR_PERMISSION_ERROR);
        return ApiService.put(`/permission/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PERMISSION_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı izin başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PERMISSION, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PERMISSION_LOADING, false);
            context.commit(SET_PERMISSION_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PERMISSION, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_PERMISSION](context, payload) {
        context.commit(SET_PERMISSION_LOADING, true);
        context.commit(CLEAR_PERMISSION_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/permission/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_PERMISSION_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
               
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı izin başarıyla silinmiştir."
                );
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_PERMISSION_ERROR, error);
        });
        
    },

    [ADD_USER_TO_PERMISSION](context, payload) {
        ApiService.post("/permission/addUser", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Ekleme Başarılı",
                    "Kullanıcı başarıyla izne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_USER_FROM_PERMISSION](context, payload) {
        ApiService.delete(`/permission/deleteUser/${payload.data.permission_id}/${payload.data.user_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "Kullanıcının izni başarıyla silinmiştir."
                );
            }   
        })
    },

    [ADD_ROLE_TO_PERMISSION](context, payload) {
        ApiService.post("/permission/addRole", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "Kullanıcı rolü başarıyla izne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_ROLE_FROM_PERMISSION](context, payload) {
        ApiService.delete(`/permission/deleteRole/${payload.data.permission_id}/${payload.data.role_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "İzin başarıyla kullanıcı rolünden silinmiştir."
                );
            }   
        })
    },
 
    
};

const mutations = {

    [SET_PAGINATED_PERMISSIONS](state, paginatedPermissions) {
        state.paginatedPermissions = paginatedPermissions.data;
    },

    [SET_ALL_PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    },

    [SET_PERMISSION_DATA](state, permissions_data) {
        state.permissions_data = permissions_data;
        state.errors = [];
    },

    [SET_PERMISSION_META](state, meta_permission) {
        state.meta_permission = meta_permission;
    },

    [SET_PERMISSION_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PERMISSION_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PERMISSION_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PERMISSION](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
